import React from "react";
import { Table, Tag, Button, Row, Col } from "antd";
import { Select, Typography, Divider, Modal, Statistic } from "antd";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
const { Option } = Select;

const { Title } = Typography;

const { Column, ColumnGroup } = Table;

class DepartmentVisual extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: null,
    };
  }

  getCurrentYearSummary = () => {
    if (
      this.props.record["Budget 2020-2021 Total"] == "..." ||
      this.props.record["Revised 2019-2020 Total"] == "..."
    ) {
      return `increades/decreased by [DATA ABSENT]`;
    }
    let difference =
      this.props.record["Budget 2020-2021 Total"] -
      this.props.record["Revised 2019-2020 Total"];
    let differencePercentage =
      (Math.abs(difference) / this.props.record["Revised 2019-2020 Total"]) *
      100;
    if (difference > 0) {
      return `has increased by  ${differencePercentage.toFixed(
        3
      )}% which amounts to ${difference.toFixed(3)} crores`;
    } else if (difference < 0) {
      return `has decreased by ${differencePercentage.toFixed(
        3
      )}% which amounts to ${Math.abs(difference.toFixed(3))} crores`;
    } else {
      return `has remained the same`;
    }
  };
  getDiscrepencySummary = () => {
    if (
      this.props.record["Budget 2019-2020 Total"] == "..." ||
      this.props.record["Revised 2019-2020 Total"] == "..."
    ) {
      return `[DATA ABSENT]`;
    }
    let difference =
      this.props.record["Revised 2019-2020 Total"] -
      this.props.record["Budget 2019-2020 Total"];
    let differencePercentage =
      (Math.abs(difference) / this.props.record["Budget 2019-2020 Total"]) *
      100;
    if (difference > 0) {
      return `was increased by ${differencePercentage.toFixed(
        3
      )}% which amounts to ${difference.toFixed(3)} crores`;
    } else if (difference < 0) {
      return `was decreased by ${differencePercentage.toFixed(
        3
      )}% which amounts to ${Math.abs(difference.toFixed(3))} crores`;
    } else {
      return ` same as the actual budget`;
    }
  };

  render() {
    return (
      <div>
   
          <Row>
            <h3>
              {this.props.record != null
                ? this.props.record["Detailed Head of Expenditure"]
                : ""}
            </h3>
            <br />
            <BarChart
              width={900}
              height={300}
              data={this.props.chartData}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis dataKey="Amount" />
              <Tooltip />
              <Legend />
              <Bar dataKey="Amount" fill="#8884d8" />
              <Bar dataKey="AmountRevised" fill="green" />

            </BarChart>
          </Row>
          {this.props.record != null ? (
            <div>
              <h3>
                <u>Brief Insights:</u>
              </h3>
              <h4>
                > The budget of 2020-21 {this.getCurrentYearSummary()} as
                compared to the past year
              </h4>
              <h4>
                > The revised budget was {this.getDiscrepencySummary()} for the
                year of 2019-20
              </h4>
            </div>
          ) : (
            ""
          )}
  
      </div>
    );
  }
}

export default DepartmentVisual;
